import React from "react";
import {Fab, Modal} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";

const useStyle = makeStyles(theme => {
    return {
        root: {
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            "& div":{
                position: "absolute",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                overflow: "hidden",
                "& > div": {
                    height: "100%",
                    minWidth: "100%",
                    position: "absolute",
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                    "& > video":{
                        width: "100%",
                        height: "100%"
                    }
                },
                "& > button": {
                    position: "absolute",
                    bottom: theme.spacing(2),
                    right: theme.spacing(2),
                    zIndex: 1
                }
            }
        }
    }
})

class ScannerView extends React.Component{
    constructor(props) {
        super(props);
        this.video = React.createRef()
        this.state = {
            aspectRatio: window.innerWidth / window.innerHeight
        }
    }

    componentDidMount() {
        const {onVideo, onSettings} = this.props
        const video = this.video.current
        video.addEventListener('loadedmetadata', () => {
            const settings = video.srcObject.getVideoTracks()[0].getSettings()
            if (onSettings){
                onSettings(settings, video)
            }
            this.setState({
                aspectRatio: settings.width / settings.height
            })
        })
        if (onVideo){
            onVideo(video)
        }
    }

    componentWillUnmount() {
        this.video.current.srcObject.getTracks().forEach(track => track.stop())
    }

    render(){
        const {aspectRatio} = this.state
        return <div
            style={{
                width: (aspectRatio * 100) + 'vh',
                minHeight: (100 / aspectRatio) + 'vw'
            }}
        >
            <video ref={this.video} autoPlay/>
        </div>
    }
}

export default function({onClose, onVideo, onSettings, children}){
    const classes = useStyle()
    return <Modal className={classes.root} open>
        <div>
            <ScannerView
                classes={classes}
                onClose={onClose}
                onVideo={onVideo}
                onSettings={onSettings}
            />
            {children}
            <Fab variant="extended" onClick={onClose}>Close</Fab>
        </div>
    </Modal>
}
